import CustomModal from 'components/global/CustomModal'
import React from 'react'
import { adminSettingStore } from 'state/setting/admin'
import AddAdminForm from './ModalContent/AddAdminForm'
import useFormSubmit from 'helper/Hooks/formSubmit'
import CustomModalFooter from 'components/global/CustomModalFooter'

const MemberFound = () => {
  const { form, handleSubmit } = useFormSubmit()
  const { mailFoundModal, setMailFoundModal, setAdminData } = adminSettingStore(
    store => ({
      mailFoundModal: store.mailFoundModal,
      setMailFoundModal: store.setMailFoundModal,
      setAdminData: store.setAdminData,
    }),
  )

  const closeModal = () => {
    setAdminData(null)
    setMailFoundModal(false)
  }

  return (
    <>
      <CustomModal
        openModal={mailFoundModal}
        isCloseModalCustom
        closeModal={closeModal}
        title="Create admin"
        footer={
          <CustomModalFooter
            multibutton={true}
            btnAlignment="justify-between"
            btnText="Cancel, Create"
            closeModal={closeModal}
            onSubmit={handleSubmit}
          />
        }
      >
        <AddAdminForm form={form} />
      </CustomModal>
    </>
  )
}

export default MemberFound
